export const PASSPORT_CLIENT = 'https://clientpassport.lessonplan.cn';
export const TEAMURL = 'https://templateserver.lessonplan.cn';
export const TSINGHUA_API = 'https://tsinghuashowserver.lessonplan.cn';
export const ORGURL = 'https://accountorg.lessonplan.cn';
export const marke_api = "https://markeserver.lessonplan.cn";
export const client_api = 'https://clientaccountserver.lessonplan.cn';
export const spm_api = 'https://secondplatformserver.lessonplan.cn';
export const micles_api = 'https://microlessonserver.lessonplan.cn';
export const TTS_api = 'https://tts.lessonplan.cn';
export const code_api = 'https://codeserver.lessonplan.cn';
export const onlinetest_api = 'https://onlinetestserver.lessonplan.cn';

export const lessonplay_data = "https://lessonplaydata.lessonplan.cn/unifydata"
//export const lessonplay_data = "http://localhost:5105/unifydata";